import actions from './actions'
import { factoryReducer } from '../factory'

// Defining the Initial Variables to be saved in the Redux Store on initialize.
const initialState = {
  notificationsList: [],
  topBarNotifications: [],
  loading: false,
  tempNotifications: [
    {
      title: 'High Respiratory',
      description: 'Resident 11-22-33',
      action: 'empty',
      seen: 0,
      createdAt: '2020-04-06 23:38:00',
      patientId: '11-22-33',
    },
  ],
}

export default factoryReducer(initialState, actions)
